/**
 * @description 自动import导入所有 api 模块
 */

// const files = require.context('./model', false, /\.js$/)
const files = import.meta.glob('@/api/model/**/*.js')
const modules = {}
// console.log(files)
Object.keys(files).forEach((key) => {
	const path = key.split('/')
	const name =  path[path.length -1].replace('.js','')
	// console.log(name)
	files[key]().then(mod=>{
		modules[name] = mod.default
	})
})

export default modules
